import { type PanelKeys } from '@databases/panel-types';
import type React from 'react';

/**
 * Simple component that renders the current database panel.
 * Panels are registered at app initialization time via the panel registry.
 *
 * @param panel - The panel key to render
 * @param panels - Optional override for testing purposes
 */
export default function PanelRenderer({
  panel,
  panels
}: {
  panel: PanelKeys | null;
  panels: Record<PanelKeys, React.ReactNode>;
}) {
  if (!panel) {
    return null;
  }

  return panels[panel] ?? null;
}
